import { CONFLUENCE_ORIGIN } from "./constants";

export const buildAttachmentUrl = (pageId, filename) => {
    if (!pageId || !filename) {
        return null;
    }

    return `${CONFLUENCE_ORIGIN}/wiki/download/attachments/${encodeURIComponent(pageId)}/${encodeURIComponent(filename)}?api=v2`;
};
